import * as React from "react";
import { SVGProps } from "react";
export function CircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={8} cy={8} r={7.5} stroke="currentColor" />
    </svg>
  );
}
